import { createApi } from "@reduxjs/toolkit/query/react";

import { adminBaseQuery } from "~/services/adminBaseApi";

export interface SwitchTenantPayload {
	errors: { message: string }[] | null;
	reAuthRequired: boolean;
	selectedTenantId: string | null;
	success: boolean;
}

export function transformSwitchTenantResponse(response: { switchTenant: SwitchTenantPayload }): SwitchTenantPayload {
	return response.switchTenant;
}

export const adminApi = createApi({
	baseQuery: adminBaseQuery,
	endpoints: (builder) => ({
		switchTenant: builder.mutation<SwitchTenantPayload, { tenantId: string }>({
			query: ({ tenantId }) => ({
				document: `
					mutation SwitchTenant($input: SwitchTenantInput!) {
						switchTenant(input: $input) {
							success
							reAuthRequired
							selectedTenantId
							errors {
								message
							}
						}
					}
				`,
				variables: { input: { tenantId } }
			}),
			transformResponse: transformSwitchTenantResponse
		})
	}),
	reducerPath: "adminApi"
});

export const { useSwitchTenantMutation } = adminApi;
